import { initialState } from './utenti.state';
import * as utentiActions from './utenti.actions';
import { Utente } from 'src/app/shared/models/utente.model';
import { Resource } from 'src/app/shared/models/resource.model';

/**
 * Funzione che gestisce gli aggiornamenti di stato dipendenti dalle azioni sulla pagina di utenti
 * @param state {State} stato a livello dello store di utenti, inizialmente valorizzato a initialState
 * @param action {UtentiAction} le azioni disponibili per lo store di utenti
 */
export function utentiReducer(state = initialState, action: utentiActions.UtentiAction) {
    switch (action.type) {
        case utentiActions.GET_USER_LIST_SUCCESS: {
            return {
                ...state,
                _elencoUtenti: action.payload.data,
                elencoFiltriUtenti: action.payload.filter,
                ordinamentoUtenti: action.payload.orderBy,
                utenteSelezionato: null,
                elencoRisorse: []
            };
        };
        case utentiActions.GET_USER_LIST_FAILURE:
        case utentiActions.CREATE_USER_FAILURE:
        case utentiActions.REMOVE_USER_FAILURE:
        case utentiActions.GET_RESOURCES_FAILURE: {
            return {
                ...state,
                errorUtenti: action.payload
            };
        };
        case utentiActions.CREATE_USER_SUCCESS: {
            let tempElencoUtenti = state._elencoUtenti.slice();
            let tempUtente = action.payload;
            tempElencoUtenti.push(tempUtente);
            return {
                ...state,
                _elencoUtenti: tempElencoUtenti.slice()
            };
        };
        case utentiActions.REMOVE_USER_SUCCESS: {
            let tempUtentiParz = state._elencoUtenti.slice();
            tempUtentiParz = tempUtentiParz.filter(utente => {
                return utente.id !== action.payload;
            });
            return {
                ...state,
                _elencoUtenti: tempUtentiParz.slice(),
                utenteSelezionato: null,
                elencoRisorse: []
            };
        };
        case utentiActions.UPDATE_USER_V2_SUCCESS: {
            let tempElencoUtenti = replaceUserInArray(state._elencoUtenti, action.payload.nuovoUtente);
            return {
                ...state,
                _elencoUtenti: tempElencoUtenti.slice(),
            };
        };
        case utentiActions.GET_RESOURCES_SUCCESS: {
            return {
                ...state,
                elencoRisorse: orderResourceByIndex(action.payload.slice())
            }
        };
        case utentiActions.GET_TRACTATES_SUCCESS: {
            return {
                ...state,
                elencoTrattati: action.payload.slice()
            };
        };
        case utentiActions.SORT_TABELLA: {
            return {
                ...state,
                ordinamentoUtenti: action.payload
            }
        }
        case utentiActions.FILTER_TABELLA: {
            return {
                ...state,
                elencoFiltriUtenti: action.payload
            };
        }
        case utentiActions.SELECT_USER: {
            return {
                ...state,
                utenteSelezionato: action.payload
            };
        };
        case utentiActions.ADD_USER_RESOURCE_SUCCESS: {
            let tempRisorseAssociate = state.elencoRisorse.slice();
            tempRisorseAssociate.push(action.payload);
            tempRisorseAssociate = orderResourceByIndex(tempRisorseAssociate);
            return {
                ...state,
                elencoRisorse: tempRisorseAssociate.slice()
            }
        };
        case utentiActions.REMOVE_USER_RESOURCE_SUCCESS: {
            let tempRisorseAssociate = state.elencoRisorse.slice();
            tempRisorseAssociate = tempRisorseAssociate.filter(risorsa => {
                return risorsa.id !== action.payload;
            });
            return {
                ...state,
                elencoRisorse: tempRisorseAssociate.slice()
            }
        };
        case utentiActions.CHANGE_DISPLAY_ADD: {
            return {
                ...state,
                displayAdd: action.payload
            }
        }
        case utentiActions.CLEAN_UTENTI_ON_DESTROY: {
            return {
                ...initialState,
                elencoTrattati: state.elencoTrattati ? state.elencoTrattati : [] //devo mantenere almeno la variabile, così da non ottenere errore navigando utenti>traduzioni
            }
        }
        default: {
            return {
                ...state
            };
        }
    }
}

/**
 * Funzione che dato un array di utenti ne restituisce uno identico in tutto meno che in un utente che viene modificato
 * @param arrayOriginale {Utente[]} array di utenti originario
 * @param utenteMod {Utente} utente modificato
 * @returns Utente[]
 */
function replaceUserInArray(arrayOriginale: Utente[], utenteMod: Utente): Utente[] {
    let copyArray = arrayOriginale.slice();
    let index = copyArray.findIndex(utenteOr => {
        return utenteOr.id === utenteMod.id;
    });
    copyArray[index] = <Utente>{ ...utenteMod };
    return copyArray;
}

/**
 * Funzione che trasforma l'indice della risorsa in una stringa che ne permetta l'annidamento, rimuovendo i punti e considerando che ogni sezione debba essere di due caratteri
 * @param indice {string} indice della risorsa in formato stringa @example 1.1.1.1
 * @returns indice della risorsa nel formato ordinabile @example 01010101
 */
function transformIndexString(indice: string): string {
    let varA = indice.split('.');
    let tempA: string;
    for (let i = 0; i < varA.length; i++) {
        tempA = tempA + varA[i].padStart(2, '0');
    }
    return tempA;
}

/**
 * Funzione che ordina le risorse in base all'indice, considerando anche le diverse suddivisioni fra trattati, capitoli, etc.
 * @param risorse {Resource[]} array delle risorse
 * @returns array delle risorse ordinato
 */
function orderResourceByIndex(risorse: Resource[]): Resource[] {
    return risorse.sort((a, b) => {
        let tempA = transformIndexString(a.index);
        let tempB = transformIndexString(b.index);
        if (tempA > tempB) {
            return 1;
        } else {
            return -1;
        }
    });
}